import { Trans } from 'react-i18next';
import React, { useContext } from 'react';
import { CampaignContext } from '../../../context/CampaignWrapper';
import LinkWithQueryParams from '../../../components/LinkWithQueryParams';

const AcceptDonations = ({ className }: { className?:string }) => {
  const { campaign: { slug = '', acceptDonations = false } = {} } = useContext(CampaignContext);

  if (!acceptDonations) return null;

  return (
    <p className={className}>
      <Trans i18nKey="COMPONENTS.ARTICLES_LIST.DONATE">
        Making a donation without ordering?
        {' '}
        <LinkWithQueryParams to={`/${slug}/checkout`}>
          <span className="text-nowrap">Continue to</span>
          {' '}
          checkout »
        </LinkWithQueryParams>
      </Trans>
    </p>
  );
};

export default AcceptDonations;
